import headerText from '@bits/article/HeaderText';
import toolsPlug from '@bits/article/ToolsPlug';
import SquareButton from '@components/bits/SquareButton';
import NoPlug from '@components/plugs/NoPlug';
import accordionInner from '@plugs/AccordionInner';
import campaignCard from '@plugs/CampaignCardInfo';
import colorPicker from '@plugs/ColorPicker';
import headerWithBody from '@plugs/HeaderWithBody';
import imageGrid from '@plugs/ImageGrid';
import singleImg from '@plugs/SingleImg';
import slider from '@plugs/Slider';
import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './index.module.scss';

const enabledPlugs = {
  headerText,
  toolsPlug,
  imageGrid,
  singleImg,
  slider,
  accordionInner,
  colorPicker,
  headerWithBody,
  campaignCard,
};

type Props = {
  data;
};

const CampainPlugElementDetails: FunctionComponent<Props> = ({ data }) => {
  const [campaignObject, setCampaignObject] = useState(null);

  useEffect(() => {
    const camp = data?.plugs?.find((val) => val._type === 'campaignCard');

    if (camp) {
      const elm = camp?.campaign;

      setCampaignObject(elm);
    }
  }, []);

  const resolvePlug = (plug): JSX.Element => {
    const Plug = enabledPlugs[plug._type];

    if (Plug) {
      return <Plug {...plug} key={plug._key} />;
    }

    return <NoPlug type={plug._type} key={plug._key} />;
  };

  const buttonText = campaignObject?.content?.campaignOrigin?.content?.carInfo?.title
    ? `om ${campaignObject?.content?.campaignOrigin?.content?.carInfo?.title}`
    : '';

  return (
    <div className={styles['root']}>
      <div className={styles['_content']}>
        <h1>{data?.page?.title}</h1>
        {data?.plugs?.map((element) => {
          return resolvePlug(element);
        })}

        {campaignObject?.content?.campaignOrigin?.content?.carInfo?.slug && (
          <div className={styles['_read-more-button']}>
            <SquareButton
              cta={campaignObject?.content?.campaignOrigin?.content?.carInfo}
              text={`Les mer ${buttonText}`}
              overrideText={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CampainPlugElementDetails;
